import React from "react";
import { Link } from "@mui/material";

export function renderMessageWithLinks(text) {
  if (!text) return "";

  return text.split(/(https?:\/\/[^\s]+|www\.[^\s]+|web\.[^\s]+)/gi).map((part, index) => {
    if (/^(https?:\/\/|www\.|web\.)[^\s]+/i.test(part)) {
      const url = part.startsWith("http") ? part : `https://${part}`;
      return (
        <Link href={url} target="_blank" rel="noopener noreferrer" key={index} color="info.main">
          {part}
        </Link>
      );
    }
    return <React.Fragment key={index}>{part}</React.Fragment>;
  });
}
